import React from "react";
import { Loading } from "../../../components/loading";
import { EmptyList } from "../../../components/empty-list";
import { useSignatures } from "../hooks";
import { formatDisplayDate } from "../../../helpers/date";
import { signatureModeLabel } from "../../../helpers/enum-labels";

interface IProps {
  orderId: number;
}

export const SignaturesList: React.FC<IProps> = ({ orderId }) => {
  const { data, loading } = useSignatures({ where: { orderId } });

  if (loading) return <Loading />;

  if (!data?.signatures?.results?.length) {
    return <EmptyList text="Aucune signature" />;
  }

  return (
    <div className="space-y-4">
      {data.signatures.results.map((signature) => (
        <div
          key={`signature-${signature.id}`}
          className="border border-gray-200 dark:border-zinc-800 rounded-md p-3"
        >
          <div className="flex flex-wrap items-start justify-between gap-2">
            <div>
              <p className="text-sm font-medium text-gray-900 dark:text-zinc-100">
                {signature.signerName}
                {signature.signerRole ? (
                  <span className="font-normal text-gray-500 dark:text-zinc-400">
                    {" "}
                    — {signature.signerRole}
                  </span>
                ) : null}
              </p>
              <p className="text-xs text-gray-500 dark:text-zinc-400 mt-0.5">
                {signatureModeLabel(signature.mode)} ·{" "}
                {formatDisplayDate(signature.signedAt)}
              </p>
            </div>
          </div>

          {signature.imagePng && (
            <img
              src={signature.imagePng}
              alt={`Signature de ${signature.signerName}`}
              className="mt-3 max-h-32 bg-white rounded border border-gray-200 dark:border-zinc-700"
            />
          )}
        </div>
      ))}
    </div>
  );
};
